var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQualitiCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.6,6.1l-14.5-6c-0.2-0.1-0.5-0.1-0.7,0l-14.1,6C0.1,6.2,0,6.4,0,6.6v7.8c0,6.5,4.9,12.3,12.5,14.9l2,0.7 c0.2,0.1,0.4,0.1,0.6,0l2.2-0.7C25,26.7,30,20.8,30,14.3V6.6C30,6.4,29.9,6.2,29.6,6.1z M28.6,14.3c0,6.1-4.7,11.6-11.9,13.9 l-1.9,0.6l-1.7-0.6C6,25.9,1.4,20.4,1.4,14.4V6.9l13.4-5.7l13.8,5.7L28.6,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,14.1c-0.3-0.2-0.7-0.3-1-0.1c-0.3,0.2-0.3,0.6-0.1,0.8l3.8,3.5c0.3,0.2,0.7,0.3,1,0.1l8.9-5.6 c0.3-0.2,0.4-0.5,0.1-0.8c-0.3-0.2-0.7-0.3-1-0.1l-8.3,5.3L9.5,14.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualitiCheck);
export default __webpack_public_path__ + "static/media/qualitiCheck.361f5e8af5e63dd4b059cd5d887552c9.svg";
export { ForwardRef as ReactComponent };